import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Pathname from './Pathname';

import page_portrait from '../assets/images/page_portrait.png';

export default class ReportSidebar extends Component {
  render(){
    var fullPathname = Pathname.fullPathname(this.props.location);

    return(
      <div className="reports-sidebar pl-4 pl-lg-0 sub-sidebar-menu">
        <ul className="nav flex-column nav-pills py-4 reports-sidebar" id="v-pills-tab" role="tablist">
          <li className="nav-item">
            <Link to='/reports/usage_report' className={`nav-link ${(fullPathname === '/reports/usage_report') && 'active'}`}>
              <img alt="Doc" src={page_portrait} className="mr-2" />
              รายงานการใช้งานระบบ
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/reports/receive' className={`nav-link ${(fullPathname === '/reports/receive') && 'active'}`}>
              <img alt="Doc" src={page_portrait} className="mr-2" />
              รายงานหนังสือรับ
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/reports/aware' className={`nav-link ${(fullPathname === '/reports/aware') && 'active'}`}>
              <img alt="Doc" src={page_portrait} className="mr-2" />
              รายงานหนังสือเวียน
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/reports/internal' className={`nav-link ${(fullPathname === '/reports/internal') && 'active'}`}>
              <img alt="Doc" src={page_portrait} className="mr-2" />
              รายงานหนังสือส่งภายใน
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/reports/external' className={`nav-link ${(fullPathname === '/reports/external') && 'active'}`}>
              <img alt="Doc" src={page_portrait} className="mr-2" />
              รายงานหนังสือส่งภายนอก
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/reports/system_usage' className={`nav-link ${(fullPathname === '/reports/system_usage') && 'active'}`}>
              <img alt="Doc" src={page_portrait} className="mr-2" />
              รายงานการใช้ระบบงาน
            </Link>
          </li>
          <li className="nav-item">
            <Link to='/reports/system_usage_statistic' className={`nav-link ${(fullPathname === '/reports/system_usage_statistic') && 'active'}`}>
              <img alt="Doc" src={page_portrait} className="mr-2" />
              รายงานสถิติการเข้าใช้งาน
            </Link>
          </li>
        </ul>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ReportSidebar.js